<app-spinner [active]="loading"></app-spinner>
<div
    [ngStyle]="{ background: 'url(assets/images/MARSBanner.png)' }"
    class="content-header"
>
  <h2 class="header-title">MARS <span class="parenthetical">(Malfunctions & Abnormalities)</span></h2>
  <h3 class="header-subtitle">Incident Table</h3>
</div>
<app-modal
  [active]="modal.active"
  [data]="modal.data"
  (confirmed)="modalConfirmed($event)"
  (denied)="modalDenied($event)"
>
</app-modal>
<!-- <div class="random-actions"> -->
<!-- <app-dropdown
    [(choice)]="selectedYear"
    label="Year"
    [(options)]="years"
    key="name"
    (selectedDropdownItem)="selectYear($event)"
    class="year-dropdown"
  ></app-dropdown>
</div> -->
<div class="incidents-table">
  <app-table
    hasActions="true"
    [settings]="settings"
    [rows]="incidents || []"
    [columns]="headings"
    (deleted)="confirmDeleteIncident($event)"
    [tableCellTemplate]="cellTemplate"
    [hideMenu]="true"
    [tallTable]="true"
  >
    <ng-template #cellTemplate let-cell="cell">
      <div class="cell" [ngClass]="{'draft': cell.value === 'Draft', 'finalized': cell.value === 'Finalized'}">
        <mat-icon
          *ngIf="cell.value === 'Draft' || cell.value === 'Finalized'"
          >{{ cell.value === "Finalized" ? 'lock' : 'schedule' }}</mat-icon
        >
        <span >{{ cell.value }}</span>
      </div>
    </ng-template>
  </app-table>
</div>
